var headerHeight = $('.navbar-site').height();
var wrapper = $('#wrapper');

// Modernizr touch event detect
function is_touch_device() {
    return 'ontouchstart' in window;
}
var isTouchDevice = is_touch_device();

// console.log('is touch device : ',isTouchDevice);

$(function() {
    var todayis = moment().format('MM/DD/YYYY');
    $('input[name="date"]').daterangepicker({
            singleDatePicker: true,
            startDate: todayis,
            showDropdowns: true,
            locale: {
                format: 'MM/DD/YYYY'
            }
        },
        function(start, end, label) {
        });
});


$(document).ready(function () {

    var navbarSite = $('.navbar-site');

    // check if RTL or LTR
    var ifrtl = false;
    var dir = $("html").attr("dir");
    var direction = "left";

    if (dir == "rtl") {
        ifrtl = true;
        // console.log(ifrtl);
        direction = "right";
        // console.log(direction)
    } else {
        // console.log(ifrtl);
        // console.log(direction)
    }

    // SET HEADER HEIGHT AS PADDING-TOP to WRAPPER

    function setWrapperHeight() {
        // console.log(headerHeight);
        wrapper.css('padding-top', headerHeight + 'px');
    }

    setWrapperHeight();

    // ON SCROLL FADE OUT -_- awesome ?? yah

    function fadeOnScroll(target) {
        var target = $('' + target + ''),
            targetHeight = target.outerHeight();
        $(document).scroll(function () {
            var scrollPercent = (targetHeight - window.scrollY) / targetHeight;
            scrollPercent >= 0 && (target.css("background-color", "rgba(0,0,0," + (1.1 - scrollPercent) + ")"))
        });
    }

    if (!isTouchDevice) {
        fadeOnScroll('.layer-bg');
    }


    /*==================================
     Carousel
     ====================================*/
    $('.bg-slider').bxSlider({
        auto: true,
        autoControls: false,
        stopAutoOnClick: true,
        mode: 'fade',
        speed: 800,
        pause: 5000,
        pager: false
    });

    $('.agents-feature').owlCarousel({
        margin: 10,
        nav: false,
        dots: true,
        responsiveClass:true,
        autoplay:true,
        autoplayTimeout:2500,
        autoplayHoverPause:true,
        responsive: {
            0: {
                items: 1,
                stagePadding: 50,
                loop: true,
                dots: true,
                lazyLoad : true,
            },
            600: {
                items: 2,
                stagePadding: 50,
                loop: true,
                dots: true,
            },
            1000: {
                loop: true,
                items: 4
            }
        }
    })

    $('.hot-offer-property').owlCarousel({
        margin: 10,
        nav: true,
        dots: false,
        responsiveClass:true,
        autoplay:true,
        autoplayTimeout:3000,
        autoplayHoverPause:true,
        navText:['<nav class="slider-nav has-white-bg nav-narrow-svg"><a class="prev"><span class="nav-icon-wrap"></span></a></nav>','<nav class="slider-nav has-white-bg nav-narrow-svg"><a class="next"><span class="nav-icon-wrap"></span></a></nav>'],
        responsive: {
            0: {
                items: 1,
                margin: 0,
                stagePadding: 50,
                loop: true,
                dots: true,
                lazyLoad : true,
            },
            600: {
                items: 2,
                margin: 0,
                stagePadding: 50,
                loop: true,
                dots: true,
            },
            1000: {
                items: 3
            }
        }
    })
   $('.filter-icon').owlCarousel({
        margin: 10,
        nav: true,
        dots:false,
        responsiveClass:true,
        autoplay:true,
        autoplayTimeout:3500,
        autoplayHoverPause:true,
        navText:['<nav class="slider-nav has-white-bg nav-narrow-svg"><a class="prev"><span class="nav-icon-wrap"></span></a></nav>','<nav class="slider-nav has-white-bg nav-narrow-svg"><a class="next"><span class="nav-icon-wrap"></span></a></nav>'],
        responsive: {
            0: {
                items: 7,
                nav: false,
                margin: 0
            },
            600: {
                items: 9,
                nav: false,
            },
            1000: {
                items: 9
            }
        }
    });
    /*==================================
     Global Plugins ||
     ====================================*/

    $('.long-list').hideMaxListItems({
        'max': 8,
        'speed': 500,
        'moreText': 'View More ([COUNT])'
    });


    $('.long-list-user').hideMaxListItems({
        'max': 12,
        'speed': 500,
        'moreText': 'View More ([COUNT])'
    });

    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    });

    $("select.selecter").niceSelect({ // custom scroll select plugin
    });

    $(".selectpicker").niceSelect({ // category list Short by
        // customClass: "select-sort-by"
    });

    $(".scrollbar").niceScroll();  //  customs scroll plugin

    // $(".loginForm").validate(); //  form validation


    // smooth scroll to the ID
    $(document).on('click', 'a.scrollto', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
    });


    /*=======================================================================================
     cat-collapse Homepage Category Responsive view
     ========================================================================================*/
    // $('.collapse-box .collapse').collapse();

    var catCollapse = $('.cat-collapse');

    $(window).bind('resize load', function () {

        if ($(this).width() < 767) {
            catCollapse.collapse('hide');
            catCollapse.on('show.bs.collapse', function () {
                $(this).prev('.cat-title').find('.icon-down-open-big').addClass("active-panel");
                //$(this).prev('.cat-title').find('.icon-down-open-big').toggleClass('icon-down-open-big icon-up-open-big');
            });

            catCollapse.on('hide.bs.collapse', function () {
                $(this).prev('.cat-title').find('.icon-down-open-big').removeClass("active-panel");
            })

        } else {
            $('#bd-docs-nav').collapse('show');
            catCollapse.collapse('show');
        }

    });

    // Change Direction based on template dir="RTL"  or dir="LTR"

    var sidebarDirection = {};
    var sidebarDirectionClose = {};

    if (ifrtl) {
        sidebarDirection = {right: '-251px'};
        sidebarDirectionClose = {right: '0'};
    }
    else {
        sidebarDirection = {left: '-251px'};
        sidebarDirectionClose = {left: '0'};
    }

    $(".filter-toggle").click(function () {
        $('.mobile-filter-sidebar')
            .prepend("<div class='closeFilter'>X</div>")
            .animate(sidebarDirectionClose, 250, "linear", function () {
            });
        $('.menu-overly-mask').addClass('is-visible');
    });

    $(".menu-overly-mask").click(function () {
        $(".mobile-filter-sidebar").animate(sidebarDirection, 250, "linear", function () {
        });
        $('.menu-overly-mask').removeClass('is-visible');
    });


    $(document).on('click', '.closeFilter', function () {
        $(".mobile-filter-sidebar").animate(sidebarDirection, 250, "linear", function () {
        });
        $('.menu-overly-mask').removeClass('is-visible');
    });


    // cityName will replace with selected location/area from location modal

    $('#selectRegion').on('shown.bs.modal', function (e) {
        // alert('Modal is successfully shown!');
        $("ul.list-link li a").click(function () {
            $('ul.list-link li a').removeClass('active');
            $(this).addClass('active');
            $(".cityName").text($(this).text());
            $('#selectRegion').modal('hide');
        });
    });

    $("#checkAll").click(function () {
        $('.add-img-selector input:checkbox').not(this).prop('checked', this.checked);
    });


    var stickyScroller = function () {
        var intialscroll = 0;
        $(window).scroll(function (event) {
            var windowScroll = $(this).scrollTop();
            if (windowScroll > intialscroll) {
                // downward-scrolling
                navbarSite.addClass('stuck');
            } else {
                // upward-scrolling
                navbarSite.removeClass('stuck');
            }
            if (windowScroll < 450) {
                // downward-scrolling
                navbarSite.removeClass('stuck');
            }
            intialscroll = windowScroll;
        });
    };

    if (!isTouchDevice) {
        stickyScroller();
    }

    $('.dropdown-clear-filter').click(function(e) {
        $(this).closest('.dropdown-menu').find('input[type="radio"]').prop('checked', false);
        $(this).closest('.dropdown-menu').find('input[type="checkbox"]').prop('checked',false);
        e.stopPropagation();
    });

    $('.dropdown-menu.stay').click(function(e) {
        // console.log('stay');
        e.stopPropagation();
    });

}); // end Ready